// src/modules/users/userService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + '/users';

// Get the auth token
const getAuthToken = () => localStorage.getItem('token');

// Set the Authorization header with the token
const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
});

// Get all users
export const getUsers = async () => {
  try {
    const response = await axios.get(`${API_URL}/`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

// Get user by ID
export const getUserById = async (id) => {
  try {
    console.log("getUserByID: ",id)
    const response = await axios.get(`${API_URL}/profile/${id}`, getHeaders());
    console.log("Response: ",response);
    return response.data;
  } catch (error) {
    console.error(`Error fetching user ${id}:`, error);
    throw error;
  }
};

// Create a new user
export const createUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/register`, userData, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

// Update an existing user
export const updateUser = async (userData) => {
  try {
    const response = await axios.put(`${API_URL}/update`, userData, getHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error updating user:`, error);
    throw error;
  }
};

// Admin update user
export const adminUpdateUser = async (id, userData) => {
  try {
    const response = await axios.put(`${API_URL}/admin/update/${id}`, userData, getHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error admin updating user ${id}:`, error);
    throw error;
  }
};

// Delete a user
export const deleteUser = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/admin/delete/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error(`Error deleting user ${id}:`, error);
    throw error;
  }
};

// Search users
export const searchUsers = async (query) => {
  try {
    const response = await axios.get(`${API_URL}/search?query=${query}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error searching users:', error);
    throw error;
  }
};

// Change password for a user
export const changeUserPassword = async (currentPassword, newPassword) => {
  try {
    const response = await axios.put(`${API_URL}/change-password`, {
      currentPassword,
      newPassword
    }, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error changing password:', error);
    throw error;
  }
};